import React from 'react';
import { Card, Badge } from '@/components/ui';
import { useNavigate } from 'react-router-dom';
import { Inbox, History, UserPlus, GitMerge, FileText, Key, ArrowRight } from 'lucide-react';
import { cn } from '@/utils/cn';

export function ApprovalsModulesGrid() {
  const navigate = useNavigate();

  const MODULES = [
    {
      id: 'pending',
      title: 'Hộp thư Trình ký',
      description: 'Danh sách các tờ trình, đề xuất mua sắm, thanh toán đang chờ bạn xem xét và phê duyệt.',
      icon: <Inbox className="w-6 h-6" />,
      color: 'blue',
      path: '/approvals/list',
      stats: '8 Chờ duyệt',
      gradient: 'from-blue-500 to-cyan-500',
      bgLight: 'bg-blue-50',
      textDark: 'text-blue-700'
    },
    {
      id: 'history',
      title: 'Lịch sử Phê duyệt',
      description: 'Tra cứu toàn bộ hồ sơ đã duyệt, từ chối hoặc yêu cầu bổ sung thông tin.',
      icon: <History className="w-6 h-6" />,
      color: 'emerald',
      path: '/approvals/history',
      stats: 'Lưu trữ',
      gradient: 'from-emerald-400 to-teal-500',
      bgLight: 'bg-emerald-50',
      textDark: 'text-emerald-700'
    },
    {
      id: 'delegation',
      title: 'Ủy quyền Xử lý',
      description: 'Cấu hình ủy quyền phê duyệt cho cấp phó khi đi công tác hoặc nghỉ phép.',
      icon: <UserPlus className="w-6 h-6" />,
      color: 'amber',
      path: '/approvals/delegation',
      stats: '2 Đang ủy quyền',
      gradient: 'from-amber-400 to-orange-500',
      bgLight: 'bg-amber-50',
      textDark: 'text-amber-700'
    },
    {
      id: 'workflow',
      title: 'Lưu đồ Quy trình (SLA)',
      description: 'Thiết lập các cấp duyệt, điều kiện tự động chuyển bước và định mức thời gian xử lý.',
      icon: <GitMerge className="w-6 h-6" />,
      color: 'purple',
      path: '/approvals/workflow',
      stats: '12 Quy trình',
      gradient: 'from-purple-500 to-pink-500',
      bgLight: 'bg-purple-50',
      textDark: 'text-purple-700'
    },
    {
      id: 'templates',
      title: 'Mẫu Tờ trình',
      description: 'Cấu hình các biểu mẫu động, trường dữ liệu bắt buộc cho từng loại đề xuất.',
      icon: <FileText className="w-6 h-6" />,
      color: 'slate',
      path: '/approvals/templates',
      stats: 'Form Builder',
      gradient: 'from-slate-500 to-gray-600',
      bgLight: 'bg-slate-100',
      textDark: 'text-slate-700'
    },
    {
      id: 'signatures',
      title: 'Chữ ký số & USB Token',
      description: 'Quản lý chứng thư số, tích hợp eKYC và xác thực ký điện tử hợp pháp.',
      icon: <Key className="w-6 h-6" />,
      color: 'indigo',
      path: '/approvals/signatures',
      stats: 'Bảo mật RSA',
      gradient: 'from-indigo-500 to-violet-500',
      bgLight: 'bg-indigo-50',
      textDark: 'text-indigo-700'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 h-full">
      {MODULES.map((mod) => (
        <Card
          key={mod.id}
          onClick={() => navigate(mod.path)}
          className="group relative overflow-hidden bg-white border-2 border-slate-100 hover:border-blue-200 shadow-sm hover:shadow-xl rounded-3xl p-6 cursor-pointer transition-all duration-300 hover:-translate-y-1 h-full flex flex-col"
        >
          <div className={cn("absolute top-0 right-0 w-32 h-32 bg-gradient-to-br opacity-5 rounded-bl-full transition-transform duration-500 group-hover:scale-110", mod.gradient)} />

          <div className="flex items-start justify-between mb-4">
            <div className={cn("w-14 h-14 rounded-2xl flex items-center justify-center shadow-inner transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3", mod.bgLight, mod.textDark)}>
              {mod.icon}
            </div>
            <Badge variant="custom" className={cn("bg-slate-50 text-slate-600 border border-slate-100 font-bold px-2.5 py-1 text-[10px]")}>
              {mod.stats}
            </Badge>
          </div>

          <h4 className="text-lg font-black text-slate-800 mb-2 group-hover:text-blue-700 transition-colors">{mod.title}</h4>
          <p className="text-xs text-slate-500 leading-relaxed mb-6 line-clamp-2 min-h-[36px] flex-grow">
            {mod.description}
          </p>

          <div className="flex items-center text-sm font-bold text-blue-600 opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300 mt-auto">
            Truy cập ngay <ArrowRight className="w-4 h-4 ml-1.5" />
          </div>
        </Card>
      ))}
    </div>
  );
}
